var openpgp = require("openpgp");

const openpgpKeys = {
    async install(Vue, options) {
        let keyConverter = async function () {
            let decryptedPrivateKeyArmored = localStorage.getItem("ruminote.privateKey");
            let publicKeyArmored = localStorage.getItem("ruminote.publicKey");
            const privKeyObj = (
                await openpgp.key.readArmored(decryptedPrivateKeyArmored)
            ).keys[0];
            const publicKeys = (await openpgp.key.readArmored(publicKeyArmored)).keys;
            let keys = {
                privateKey: privKeyObj,
                publicKey: publicKeys
            };
            Vue.prototype.$openpgpKeys = keys;
        };
        let decryptedPrivateKeyArmored = localStorage.getItem("ruminote.privateKey");
        let publicKeyArmored = localStorage.getItem("ruminote.publicKey");
        let keys = null;
        if (decryptedPrivateKeyArmored && publicKeyArmored) {
            keys = await keyConverter();
        }
        Vue.prototype.$createOpenpgpKeys = keyConverter;
    }
};
export default openpgpKeys;